import { CloseButtonProps, ToastContainer } from "react-toastify";
import Button from "../Button/button";
import styles from "./toasNotification.module.css";

const CloseButton = ({ closeToast }: CloseButtonProps) => (
  <Button
    className={styles.closeButton}
    text=""
    // Do not pass the click event into closeToast — react-toastify treats the
    // first arg as removalReason and crashes when it is a MouseEvent.
    onClick={() => closeToast()}
  />
);

export const ToastProvider = () => (
  <ToastContainer
    className="!w-full"
    toastClassName="!bg-[rgb(242_242_244)] !w-fit"
    position="top-center"
    icon={false}
    stacked={true}
    closeButton={CloseButton}
    autoClose={7000}
  />
);
